import { render } from "./WCEmployeeAssociationBanner.vue?vue&type=template&id=072a255a&scoped=true"
import script from "./WCEmployeeAssociationBanner.vue?vue&type=script&lang=js"
export * from "./WCEmployeeAssociationBanner.vue?vue&type=script&lang=js"

import "./WCEmployeeAssociationBanner.vue?vue&type=style&index=0&id=072a255a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-072a255a"]])

export default __exports__